import { render } from "./TemplateMyCouponsIndex.vue?vue&type=template&id=655e7f65"
import script from "./TemplateMyCouponsIndex.vue?vue&type=script&lang=js"
export * from "./TemplateMyCouponsIndex.vue?vue&type=script&lang=js"
script.render = render

export default script